// src/api/api.js
import axios from "axios";

/**
 * English:
 * Single source of truth for HTTP requests.
 * - Cookie-based auth only (httpOnly cookies)
 * - No Authorization/Bearer headers anywhere
 * - withCredentials ensures cookies are sent automatically
 *
 * CRA note:
 * - CRA uses process.env.REACT_APP_*
 * - Keep a safe localhost fallback for dev
 */
// - Production (A1 same origin): use relative baseURL ("") so requests go to same domain
// - Development: use env or fallback to localhost backend
const baseURL = (
  process.env.NODE_ENV === "production"
    ? ""
    : (process.env.REACT_APP_API_URL || "http://localhost:5000")
).replace(/\/$/, "");

const api = axios.create({
  baseURL,
  timeout: 15000,
  withCredentials: true, // English: Always send cookies
});

export default api;